import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const saveRatingReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_SAVE_RATING:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_SAVE_RATING_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_SAVE_RATING_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_SAVE_RATING:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default saveRatingReducer
